import React from "react";

interface AvgVideoUploadTimeGraphDataProps {}

export const AvgVideoUploadTimeGraphData: React.FC<AvgVideoUploadTimeGraphDataProps> = () => {
  return <div></div>;
};
